import React from "react";
import PropTypes from "prop-types";
import SimpleHeader from "../SimpleHeader";
import Headline from "../Typography/Headline";
import i18next from "i18next";
import TextInput from "../Forms/TextInput";
import { getSvgIcon } from "../../Helpers/get-assets";
import Button from "../Button";
import SimpleButton from "../Button/SimpleButton";

const JoinGroupOrder = ({
    ownerName,
    formatedDate,
    dispatchType,
    heroImageSrc,
    name,
    setName,
    onJoinGroup,
    slotValidTill,
    onBackClick = () => null,
    loading = false,
    location,
}) => {
    const bicycleIcon = getSvgIcon(`bicycle.svg`);
    const shopIcon = getSvgIcon("shop.svg");
    const isPickup = dispatchType === "pickup";

    return (
        <>
            <SimpleHeader onBackClick={onBackClick} />
            <div className="join-group-order">
                <div className="join-group-order__left">
                    <h3 className="join-group-order__subtitle">
                        {i18next.t("joinGroupOrder.subTitle")}
                    </h3>
                    <Headline size={4} className="join-group-order__title">
                        {i18next.t("joinGroupOrder.title", {
                            name: ownerName,
                        })}
                    </Headline>
                    <br />
                    <p className="join-group-order__text">
                        <img
                            src={isPickup ? shopIcon : bicycleIcon}
                            alt="dispatchType"
                            className="join-group-order__icon"
                        />
                        <span>
                            {i18next.t(`joinGroupOrder.${dispatchType}`)}
                        </span>
                    </p>
                    <p className="join-group-order__text">
                        <span className="join-group-order__iconText">
                            {i18next.t(`joinGroupOrder.location`)}
                        </span>

                        <span>{location}</span>
                    </p>
                    <p className="join-group-order__text">
                        <span className="join-group-order__iconText">
                            {i18next.t(`joinGroupOrder.time`)}
                        </span>
                        <div>
                            <span>{formatedDate}</span>
                            <span>
                                <strong>
                                    {i18next.t("joinGroupOrder.finishTill", {
                                        till: slotValidTill,
                                    })}
                                </strong>
                            </span>
                        </div>
                    </p>
                    <p className="join-group-order__text">
                        <span className="join-group-order__iconText">
                            {i18next.t(`joinGroupOrder.creditCard`)}
                        </span>
                        <span>
                            {i18next.t("joinGroupOrder.payedBy", {
                                name: ownerName,
                                till: slotValidTill,
                            })}
                        </span>
                    </p>
                    <p>
                        {i18next.t(`joinGroupOrder.description`, {
                            name: ownerName,
                        })}
                    </p>
                    <TextInput
                        bindName="name"
                        label={i18next.t(`joinGroupOrder.inputName`)}
                        onChange={(value) => setName(value)}
                        value={name}
                    />
                    <Button
                        label={i18next.t(`joinGroupOrder.buttonJoinGroup`)}
                        onClick={() => onJoinGroup(name)}
                        disabled={name === "" || name === undefined}
                        size="SM"
                        loading={loading}
                    />
                    <SimpleButton
                        onClick={onBackClick}
                        label={i18next.t(`joinGroupOrder.buttonDeclineGroup`)}
                        asText
                        disabled={loading}
                    />
                </div>
                <div className="join-group-order__right">
                    <img
                        src={heroImageSrc}
                        className="join-group-order__hero"
                        alt="group-order-hero"
                    />
                </div>
            </div>
        </>
    );
};

JoinGroupOrder.propTypes = {
    ownerName: PropTypes.string,
    formatedDate: PropTypes.string,
    onBackClick: PropTypes.func,
    name: PropTypes.string,
    setName: PropTypes.func,
    heroImageSrc: PropTypes.string,
    dispatchType: PropTypes.string,
    onJoinGroup: PropTypes.func,
    location: PropTypes.string,
    loading: PropTypes.bool,
    slotValidTill: PropTypes.string,
};

export default JoinGroupOrder;
